import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import { useMapContext } from '../Map/MapContext';

const RunModel = () => {
    const [isModelRunningDialogOpen, setIsModelRunningDialogOpen] = useState(false);
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

    const { 
        inpFile, 
        outFileExists, 
        devPlanContent,
        selectedLayer, 
        userData,
        devPlanID,
        selectedStormOption

    } = useMapContext();

    const handleMakeItRain = async () => {
        if (!inpFile) {
            console.error('No inp file available');
            return;
        }

        const fileName = inpFile.replace('.inp', '');

        const check_inp_url = `https://2471d2z813.execute-api.us-east-2.amazonaws.com/read-lid/${fileName}`;
        try {
            const response = await fetch(check_inp_url, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                if (data.message) {
                    console.log('Inp file does not exist:', data.message);
                }
                if (devPlanContent) {

                    for (const [subcatch_id, value] of Object.entries(devPlanContent)) {
                        for (const [LIDType, LIDData] of Object.entries(value)) {
                            const lid = {
                                'subcatch_id': subcatch_id, 
                                'lid_name': LIDType, 
                                'n_replicate': parseInt(LIDData.n_replicate), 
                                'area': parseFloat(LIDData.area)
                            };
                            const user = {
                                'user_id': userData.id, 
                                'dev_plan': devPlanID
                            };
                            const base_model = `GLWA_${selectedStormOption}`;
                            const requestData = {
                                base_model: base_model,
                                user: user,
                                lid: lid
                            };

                            fetch('https://2471d2z813.execute-api.us-east-2.amazonaws.com/add-lid', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json',},
                                body: JSON.stringify(requestData)
                            })
                            .then(response => response.json())
                            .then(data => {
                                console.log('Success:', data);
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                        }
                    }
                }
                console.log('All done updating the inp file now!')
            } else {
                console.error('Error checking inp file:', response);
            }
        } catch (error) {
            console.error('Error checking inp file:', error);
        }
        
        const url = `https://2471d2z813.execute-api.us-east-2.amazonaws.com/run-model/${fileName}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
            });
    
            if (response.ok) {
                const data = await response.json();
                console.log('Model run successful:', data);
                setIsModelRunningDialogOpen(true);
                setIsConfirmationDialogOpen(false);
            } else {
                console.error('Error running model:', response.statusText);
            }
        } catch (error) {
            console.error('Error running model:', error);
        }
    };

    return (
        <div>
            {!outFileExists && Object.keys(devPlanContent).length > 0 && (
                <Button
                    variant="contained"
                    startIcon={<ThunderstormIcon />}
                    style={{
                        zIndex: 1000,
                        position: 'absolute',
                        top: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#94cfec',
                        color: '#000',
                        borderRadius: '5px',
                        padding: '10px 20px',
                    }}
                    onClick={() => setIsConfirmationDialogOpen(true)} // Open confirmation dialog instead
                >
                    Make it Rain
                </Button>
            )}

            {/* Confirmation Dialog */}
            <Dialog
                open={isConfirmationDialogOpen}
                onClose={() => setIsConfirmationDialogOpen(false)}
            >
                <DialogTitle>Confirm Model Run</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This will run the model. Are you sure?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsConfirmationDialogOpen(false)}>Go back</Button>
                    <Button onClick={handleMakeItRain} autoFocus>Run it!</Button>
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={isModelRunningDialogOpen}
                onClose={() => setIsModelRunningDialogOpen(false)}
            >
                <DialogTitle>Model Running</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        The model is now running. This should take about an hour. 
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsModelRunningDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default RunModel;